(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["device-finder"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-svfind]');
  if(!root) return;

  var KEY = 'sv_device';
  function saveDevice(handle,label,url){
    try { localStorage.setItem(KEY, JSON.stringify({ handle:handle, label:label, url:url })); } catch(e){}
    try { window.dispatchEvent(new Event('sv-device-changed')); } catch(e){}
  }

  // every selectable link writes the device before navigating (progressive: still a real <a href>)
  var picks = [].slice.call(root.querySelectorAll('.svfind__pick'));
  var rowByLabel = {};
  picks.forEach(function(a){
    rowByLabel[a.getAttribute('data-label')] = a;
    a.addEventListener('click', function(){
      saveDevice(a.getAttribute('data-handle'), a.getAttribute('data-label'), a.getAttribute('data-url'));
      // let default navigation proceed
    });
  });
  function urlFor(label){ var a = rowByLabel[label]; return a ? a.getAttribute('data-url') : null; }
  function handleFor(label){ var a = rowByLabel[label]; return a ? a.getAttribute('data-handle') : null; }
  function existsLabel(label){ return !!rowByLabel[label]; }

  /* ------------------------------------------------------------------ SEARCH */
  var searchbar = root.querySelector('[data-svfind-searchbar]');
  var search = root.querySelector('[data-svfind-search]');
  var rows = [].slice.call(root.querySelectorAll('.svfind__row'));
  var series = [].slice.call(root.querySelectorAll('.svfind__series'));
  var groups = [].slice.call(root.querySelectorAll('.svfind__group'));
  var empty = root.querySelector('[data-svfind-empty]');
  if(searchbar) searchbar.hidden = false;
  function applyFilter(q, brand){
    q = (q||'').trim().toLowerCase(); var any=false;
    rows.forEach(function(r){
      var okQ = !q || (r.getAttribute('data-search')||'').indexOf(q) > -1;
      var g = r.closest('.svfind__group');
      var okB = !brand || brand==='all' || (g && g.getAttribute('data-svfind-group')===brand);
      var show = okQ && okB;
      r.style.display = show ? '' : 'none';
      if(show) any=true;
    });
    series.forEach(function(s){ var vis=s.querySelectorAll('.svfind__row:not([style*="none"])').length; s.style.display=vis?'':'none'; });
    groups.forEach(function(g){ var vis=g.querySelectorAll('.svfind__row:not([style*="none"])').length; g.style.display=vis?'':'none'; });
    if(empty) empty.hidden = any;
  }
  var curBrand='all';
  if(search) search.addEventListener('input', function(){ applyFilter(this.value, curBrand); });

  /* -------------------------------------------------------------------- TABS */
  var tabsWrap = root.querySelector('[data-svfind-tabs]');
  if(tabsWrap){
    tabsWrap.hidden = false;
    [].slice.call(tabsWrap.querySelectorAll('.svfind__tab')).forEach(function(t){
      t.addEventListener('click', function(){
        curBrand = t.getAttribute('data-svfind-tab');
        [].slice.call(tabsWrap.querySelectorAll('.svfind__tab')).forEach(function(x){
          var on = x===t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on?'true':'false');
        });
        applyFilter(search?search.value:'', curBrand);
      });
    });
  }

  /* --------------------------------------------------------------- DETECTION */
  var band = root.querySelector('[data-svfind-detect]');

  // Samsung model-code (SM-xxxx) core → store label. Covers the high-volume modern range;
  // anything unmapped falls through to the picker + guided steps (honest, never a wrong guess).
  var SAMSUNG = {
    'S938':'Samsung S25 Ultra','S936':'Samsung S25 Plus','S931':'Samsung S25','S937':'Samsung S25 Edge','S731':'Samsung S25 FE',
    'S928':'Samsung S24 Ultra','S926':'Samsung S24 Plus','S921':'Samsung S24','S721':'Samsung S24 FE',
    'S918':'Samsung S23 Ultra','S916':'Samsung S23 Plus','S911':'Samsung S23','S711':'Samsung S23 FE',
    'S908':'Samsung S22 Ultra','S906':'Samsung S22 Plus','S901':'Samsung S22',
    'G998':'Samsung S21 Ultra','G996':'Samsung S21 Plus','G991':'Samsung S21','G990':'Samsung S21 FE',
    'G988':'Samsung S20 Ultra','G986':'Samsung S20 Plus','G985':'Samsung S20 Plus','G981':'Samsung S20','G980':'Samsung S20','G780':'Samsung S20 FE','G781':'Samsung S20 FE',
    'N986':'Samsung Note 20 Ultra','N985':'Samsung Note 20 Ultra','N981':'Samsung Note 20','N980':'Samsung Note 20',
    'N976':'Samsung Note 10 Plus','N975':'Samsung Note 10 Plus','N971':'Samsung Note 10','N970':'Samsung Note 10','N770':'Samsung Note 10 Lite',
    'A566':'Samsung A36/A56','A556':'Samsung A55','A546':'Samsung A54','A536':'Samsung A53','A528':'Samsung A52','A526':'Samsung A52','A525':'Samsung A52','A515':'Samsung A51','A505':'Samsung A50',
    'A366':'Samsung A36/A56','A356':'Samsung A35','A346':'Samsung A34','A336':'Samsung A33','A326':'Samsung A32','A325':'Samsung A32',
    'A266':'Samsung A26','A256':'Samsung A25','A236':'Samsung A23','A226':'Samsung A22 5G','A217':'Samsung A21',
    'A165':'Samsung A16','A166':'Samsung A16','A155':'Samsung A16','A156':'Samsung A16','A145':'Samsung A14','A146':'Samsung A14','A135':'Samsung A13','A137':'Samsung A13','A127':'Samsung A12','A125':'Samsung A12','A057':'Samsung A05s','A055':'Samsung A05','A047':'Samsung A04s','A045':'Samsung A04','A037':'Samsung A02s',
    'A105':'Samsung A10','A202':'Samsung A20e'
  };
  function samsungLabel(model){
    if(!model) return null;
    var m = (''+model).toUpperCase().replace(/\s+/g,'');
    var core = m.replace(/^SM[-_]?/,'').slice(0,4);           // e.g. SM-S911B → S911
    if(SAMSUNG[core]) return SAMSUNG[core];
    // Pixel & OnePlus & others: not in store range → let picker handle it
    return null;
  }

  // iPhone: Safari never reveals the model → fingerprint screen (CSS px) × dpr → candidate labels
  // (newest-first). Only labels that exist as rows are shown, so it's an honest shortlist.
  var IPHONE = {
    '320x568@2':['iPhone 6'],
    '375x667@2':['iPhone 7/8','iPhone 6'],
    '414x736@3':['iPhone 7/8 Plus'],
    '375x812@3':['iPhone 11 Pro','iPhone X'],
    '360x780@3':['iPhone 13 Mini'],
    '414x896@2':['iPhone 11','iPhone XR'],
    '414x896@3':['iPhone 11 Pro Max','iPhone XS Max'],
    '390x844@3':['iPhone 14','iPhone 13','iPhone 13 Pro','iPhone 12/12 Pro'],
    '428x926@3':['iPhone 14 Plus','iPhone 13 Pro Max','iPhone 12 Pro Max'],
    '393x852@3':['iPhone 17','iPhone 16','iPhone 15','iPhone 15 Pro','iPhone 14 Pro'],
    '430x932@3':['iPhone 17 Pro Max','iPhone 16 Plus','iPhone 15 Plus','iPhone 15 Pro Max','iPhone 14 Pro Max'],
    '402x874@3':['iPhone 17 Pro','iPhone 16 Pro'],
    '440x956@3':['iPhone 17 Pro Max','iPhone 16 Pro Max']
  };
  function iphoneCandidates(){
    try {
      var w = Math.min(screen.width, screen.height), h = Math.max(screen.width, screen.height);
      var dpr = Math.round(window.devicePixelRatio || 2);
      var key = w + 'x' + h + '@' + dpr;
      return (IPHONE[key] || []).filter(existsLabel);
    } catch(e){ return []; }
  }

  function isiOS(){
    return /iPad|iPhone|iPod/.test(navigator.platform) ||
      (/Macintosh/.test(navigator.userAgent) && 'ontouchend' in document) ||
      /iPhone|iPad|iPod/.test(navigator.userAgent);
  }

  function el(tag, cls, html){ var e=document.createElement(tag); if(cls) e.className=cls; if(html!=null) e.innerHTML=html; return e; }
  function esc(s){ return (''+s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  function showScanning(){
    band.hidden=false; band.setAttribute('data-state','scanning');
    band.innerHTML=''; band.appendChild(el('span','svfind__scan-dot'));
    band.appendChild(el('span',null,'Athuga tækið þitt…'));
  }
  function clearMatches(){ rows.forEach(function(r){ r.classList.remove('is-match'); }); }
  function markMatch(label){ var a=rowByLabel[label]; if(a){ var r=a.closest('.svfind__row'); if(r) r.classList.add('is-match'); } }

  function goLink(label){
    var url = urlFor(label); if(!url) return '#';
    return url;
  }
  function buildGo(label){
    var a = el('a','svfind__cta','Já — sýndu mér hulstur ' +
      '<svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h9M8.5 4.5 12 8l-3.5 3.5" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    a.setAttribute('href', goLink(label));
    a.addEventListener('click', function(){ saveDevice(handleFor(label), label, urlFor(label)); });
    return a;
  }

  // single, high-confidence result (Android UA-CH) — confirm Yes / No
  function showConfirm(label){
    clearMatches(); markMatch(label);
    band.setAttribute('data-state','found'); band.innerHTML='';
    band.appendChild(el('p','svfind__detect-title','Þú virðist vera með'));
    band.appendChild(el('span','svfind__detect-model', esc(label.replace(/^Samsung /,'Samsung ').replace(/^iPhone /,'iPhone '))));
    var act = el('div','svfind__detect-actions');
    act.appendChild(buildGo(label));
    var no = el('button','svfind__cta svfind__cta--ghost','Nei, velja handvirkt');
    no.addEventListener('click', function(){ dismissToPicker(); });
    act.appendChild(no);
    band.appendChild(act);
    band.hidden=false;
  }

  // iPhone shortlist — pick the right one (no false certainty)
  function showShortlist(cands){
    clearMatches(); cands.forEach(markMatch);
    band.setAttribute('data-state','found'); band.innerHTML='';
    band.appendChild(el('p','svfind__detect-title','Þú ert með iPhone 📱'));
    band.appendChild(el('p','svfind__detect-sub','Veldu réttu gerðina — við sendum þig beint á hulstrin sem passa.'));
    var chips = el('div','svfind__chips');
    cands.slice(0,5).forEach(function(label){
      var c = el('a','svfind__chip', esc(label.replace(/^iPhone /,'')));
      c.setAttribute('href', goLink(label));
      c.addEventListener('click', function(){ saveDevice(handleFor(label), label, urlFor(label)); });
      chips.appendChild(c);
    });
    band.appendChild(chips);
    var more = el('button','svfind__cta svfind__cta--ghost','Engin passar — sýna allar gerðir');
    more.style.marginTop='14px';
    more.addEventListener('click', function(){ dismissToPicker(); });
    band.appendChild(more);
    band.hidden=false;
  }

  function showUnknown(){
    band.setAttribute('data-state','unknown'); band.innerHTML='';
    band.appendChild(el('p','svfind__detect-title','Veldu símann þinn hér að neðan'));
    band.appendChild(el('p','svfind__detect-sub','Við gátum ekki greint tækið sjálfkrafa. Finndu gerðina í listanum — eða opnaðu leiðbeiningarnar neðst.'));
    band.hidden=false;
  }
  function dismissToPicker(){
    clearMatches(); band.hidden=true;
    if(search){ try{ search.focus(); }catch(e){} }
    else { var b=root.querySelector('.svfind__body'); if(b) b.scrollIntoView({behavior:'smooth',block:'start'}); }
  }

  // test override for QA:  ?sv_test=android:SM-S911B | ios:393x852@3 | unknown
  function testOverride(){
    try {
      var q = new URLSearchParams(location.search).get('sv_test'); if(!q) return false;
      if(q === 'unknown'){ showUnknown(); return true; }
      if(q.indexOf('android:')===0){ var lbl=samsungLabel(q.slice(8)); if(lbl && existsLabel(lbl)){ showConfirm(lbl); } else { showUnknown(); } return true; }
      if(q.indexOf('ios:')===0){ var cands=(IPHONE[q.slice(4)]||[]).filter(existsLabel); if(cands.length===1){ showConfirm(cands[0]); } else if(cands.length){ showShortlist(cands); } else { showUnknown(); } return true; }
    } catch(e){}
    return false;
  }

  function detect(){
    showScanning();
    if(testOverride()) return;

    // 1) Android / Samsung via UA Client Hints (reliable model)
    var uaData = navigator.userAgentData;
    if(uaData && typeof uaData.getHighEntropyValues === 'function'){
      uaData.getHighEntropyValues(['model','platform']).then(function(hi){
        var plat = (hi.platform||'').toLowerCase();
        if(plat.indexOf('android') > -1){
          var lbl = samsungLabel(hi.model);
          if(lbl && existsLabel(lbl)){ showConfirm(lbl); return; }
          showUnknown(); return;
        }
        // Chromium on iOS is still WebKit; fall through to iOS path
        finishNonAndroid();
      }).catch(finishNonAndroid);
      return;
    }
    finishNonAndroid();
  }

  function finishNonAndroid(){
    if(isiOS()){
      var cands = iphoneCandidates();
      if(cands.length === 1){ showConfirm(cands[0]); return; }
      if(cands.length){ showShortlist(cands); return; }
    }
    showUnknown();
  }

  // slight delay so the "scanning" state is perceptible (feels considered, not janky)
  setTimeout(detect, 260);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skjavorn-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    for (const root of document.querySelectorAll('.sv-sp')) {
      const videos = root.querySelectorAll('video');
      if (!videos.length) continue;
      const toggle = root.querySelector('.sv-sp__vidtoggle');
      const setPaused = (paused) => {
        for (const v of videos) {
          if (paused) { v.pause(); }
          else { const p = v.play(); if (p) { p.catch(function () {}); } }
        }
        if (toggle) {
          toggle.classList.toggle('is-paused', paused);
          const label = paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause;
          if (label) { toggle.setAttribute('aria-label', label); }
        }
      };
      if (reduce.matches) { setPaused(true); }
      if (toggle) {
        toggle.addEventListener('click', function () {
          let anyPlaying = false;
          for (const v of videos) { if (!v.paused) { anyPlaying = true; break; } }
          setPaused(anyPlaying);
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
